// CommonJS: cron/*.mjs imports this too, under plain Node (no .ts).
// Product name -> slug, matching v1: "havo Economie 2026/2027" -> "havo-economie-2026-2027".
function productSlug (slug) {
  if (typeof slug !== 'string' || !slug) {
    return ''
  }

  return slug
    .toLowerCase()
    .replace(/[\s/]+/g, '-')
    .replace(/[^a-z0-9-]+/g, '')
    .replace(/-{2,}/g, '-')
    .replace(/^-+|-+$/g, '')
}

module.exports = {
  productSlug
}
